import React, { Component } from "react";
import PropTypes from "prop-types";
import { InputContainer, TextInput } from "careconnect-ui";

class ReduxFieldText extends Component {
  render() {
    const {
      label,
      labelFor,
      input: { value, onChange, onBlur, type },
      meta: { error, touched },
      helpText,
        required,
      disabled,
      ...props
    } = this.props;
    return (
      <InputContainer 
        label={label}
        labelFor={labelFor}
        required={required}
        error={touched && error && error.length !== 0}
        helpText={touched && error ? error : helpText}
      >
            <TextInput disabled={disabled}
          onChange={onChange}
          onBlur={val => onBlur(val)}
          value={value}
          type={type}
          {...props}
        />
      </InputContainer>
    );
  }
}

export default ReduxFieldText;

ReduxFieldText.propTypes = {
  /** Label to display above the text field*/
  label: PropTypes.string,
  /** Id of the input that the label references*/
  labelFor: PropTypes.string,
  /** Input object following Redux API*/
  input: PropTypes.object,
  /** Meta object following Redux API*/
  meta: PropTypes.object,
  /** Whether or not the field is Required **/
  required: PropTypes.string
};
